export const MONTHS = [
  { month: 1, name: 'January' },
  { month: 2, name: 'February' },
  { month: 3, name: 'March' },
  { month: 4, name: 'April' },
  { month: 5, name: 'May' },
  { month: 6, name: 'June' },
  { month: 7, name: 'July' },
  { month: 8, name: 'August' },
  { month: 9, name: 'September' },
  { month: 10, name: 'October' },
  { month: 11, name: 'November' },
  { month: 12, name: 'December' },
];

export const YEARS = [
  { year: 2017, name: '2017' },
  { year: 2018, name: '2018' },
  { year: 2019, name: '2019' },
  { year: 2020, name: '2020' },
  { year: 2021, name: '2021' },
  { year: 2022, name: '2022' },
  { year: 2023, name: '2023' },
  { year: 2024, name: '2024' },
  { year: 2025, name: '2025' },
  { year: 2026, name: '2026' },
  { year: 2027, name: '2027' },
  { year: 2028, name: '2028' },
  { year: 2029, name: '2029' },
  { year: 2030, name: '2030' },
  { year: 2031, name: '2031' },
  { year: 2032, name: '2032' },
  { year: 2033, name: '2033' },
  { year: 2034, name: '2034' },
  { year: 2035, name: '2035' },
  { year: 2036, name: '2036' },
  { year: 2037, name: '2037' },
];



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/consts/date.const.ts